import { Outlet } from 'react-router-dom';
import MainHeader from './header';
import { Avatar, Button, Card, CardContent, Input, Typography, Box, Divider } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import { get, getFile, post, postImage } from 'api/apiBridges/httpBridge';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import { Email, Margin } from '@mui/icons-material';
import Loading from 'components/Load';
import { enqueueSnackbar } from 'notistack';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { colors } from 'styles/colors';
import { onChangeUploadImage } from 'store/slices/uploadImage';
import useOn from 'components/socketLib/UseOn';
//import EditIcon from '@mui/icons-material/Edit';
import UserAvatar from "../components/EIComponents/UserAvatar";
import { useLocalNotifications } from 'components/Events';
import HomeIcon from '@mui/icons-material/Home';
import {NumInputDesign, useAdaptiveFontSize, TextInputDesign } from "../components/EIComponents/LittleComponents";
import EditIcon from '../images/others/EditIcon.png';
import Scrollbars from "rc-scrollbars";

const ClientSettings = () => {

  const { user_id, role } = useSelector(
      loginSelector
  );

  const [loading, setLoading] = useState(true);
  const [changed, setChanged] = useState(false);
  const [user, setUser] = useState({
      email: "",  
      fio: "",
      mobile_number: "",
      photo: undefined,
      marketPhoto: undefined
  })

  const { showNotification } = useLocalNotifications();

  const { socket } = useContext(SocketContext);
  const dispatch = useDispatch();
  const onSubmit = useCallback((data) => {
    dispatch(onChangeUploadImage(data));
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const responseData = await get('Clients/get', {cid:user_id});
        if (responseData?.message) {
          let photo = undefined
          let marketPhoto = undefined
          if (responseData.message.data) {
            let clidata = JSON.parse(responseData.message.data)
            photo = clidata?.photo
            // marketPhoto = clidata?.marketPhoto
            let img = await getFile("png", { path:clidata?.marketPhoto });
            if (typeof img === "string") {
              marketPhoto = img
            }
          }
          let obj = {
              email: responseData.message.email || "Не указано",  
              fio: responseData.message.fio || "Не указано",
              mobile_number: responseData.message.mobile_number || "Не указано",
              photo,
              marketPhoto

          }
          setUser(obj)
        }
        } catch (err) {
        } finally {
        setLoading(false);
        }
    };

    fetchData();
  }, []);

  const phoneRegex = /^\+7\d{10}$/;
  const emailRegex = /^.+@.+\..{2,}$/;

  const change = (path, val) => {
    console.log('CHANGE', path, val)
     // let finalValue = val;
    // if (path === 'mobile_number') {
    //   let rawValue = val.replace(/\s/g, '');
    //   let cleanedValue = rawValue.replace(/^(7|8)/, '+7');

    //   if (!cleanedValue.startsWith('+7')) {
    //     cleanedValue = rawValue.startsWith('+') 
    //       ? '+' + rawValue.slice(1).replace(/[^\d]/g, '') 
    //       : rawValue.replace(/[^\d+]/g, '');
    //     cleanedValue = cleanedValue.replace(/^(7|8)/, '+7');
    //   }
    //   cleanedValue = cleanedValue.replace(/[^\d+]/g, '');

    //   if (cleanedValue.startsWith('+7') && cleanedValue.length > 12) {
    //     cleanedValue = cleanedValue.substring(0, 12);
    //   } else if (cleanedValue.length > 11 && !cleanedValue.startsWith('+')) {
    //     cleanedValue = cleanedValue.substring(0, 11);
    //   }
    //   finalValue = cleanedValue;
    // }

    setUser(prev => ({ ...prev, [path]: val }));
    setChanged(true);
  };

  const save = () => {
    const isPhoneValid = user.mobile_number.trim() !== '' && user.mobile_number !== "Не указано"
    const isEmailValid = emailRegex.test(user.email);
    const isNameValid = user.fio.trim() !== '' && user.fio !== "Не указано";

    if (isNameValid && isPhoneValid && isEmailValid) {
      post('Clients/addupdate', {
        id: user_id,
        fio: user.fio,
        email: user.email,
        mobile_number: user.mobile_number.replace(/\D/g, '')
      });
      socket.emit("userSettingsUpdateSet", {
        id: user_id,
        fio: user.fio,
        email: user.email,
        mobile_number: user.mobile_number.replace(/\D/g, '')
      });
      setChanged(false);
      enqueueSnackbar('Настройки сохранены', { variant: 'success' });
    } else {
      if (!isNameValid) {
        showNotification({
              id: 'noName', 
              type: 'error', 
              message: 'Не введено имя' 
          });
      } else if (user.mobile_number == '') {
        showNotification({
              id: 'wrongNumber', 
              type: 'error', 
              message: 'Не введен номер' 
          });
      } else if (!isEmailValid) {
        showNotification({
              id: 'wrongEmail', 
              type: 'error', 
              message: 'Неправильно введена почта' 
          });
      } else {
        showNotification({
              id: 'noData', 
              type: 'error', 
              message: 'Недостаточно данных' 
          });
      }
    }

  };

  const handleFileUpload = useCallback(async (event) => {
    let selectedFiles = Array.from(event.target.files);
      if (selectedFiles) {
        let rightFiles = []
        selectedFiles.map((file) => {
          if (file.type === "image/png" || file.type === "image/jpeg") {
            rightFiles.push(file)
          }
          else {
            showNotification({
              id: 'uploadDealImageErr', // Уникальный идентификатор
              type: 'error', // Тип уведомления
              message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
            });
          }
        })
        if (rightFiles.length > 0 ) {
          onSubmit({ upload: true });
          // enqueueSnackbar('Загрузка изображения...', { variant: 'info', autoHideDuration: 5000 });
          showNotification({
            id: 'uploadCSImage', // Уникальный идентификатор
            type: 'info', // Тип уведомления
            message: 'Загрузка' // Текст сообщения
          });

          postImage(rightFiles, socket.id, {user_id, role, content_type:"uploadAvatar"}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
        }
      }
  }, [onSubmit]);

    useOn('setMarketIcon', async (data) => {
      if (data?.user_id === user_id ) {
        let photo = undefined;
        if (data.path) {
          photo = await getFile("png", { path:data.path })
          let tmp = JSON.parse(JSON.stringify(user))
          tmp.marketPhoto = photo
          setUser(tmp)
        }
      }      
  });


  const handleMarketFileUpload = useCallback(async (event) => {
      let selectedFiles = Array.from(event.target.files);
      if (selectedFiles) {
        let rightFiles = []
        selectedFiles.map((file) => {
          if (file.type === "image/png" || file.type === "image/jpeg") {
            rightFiles.push(file)
          }
          else {
            showNotification({
              id: 'uploadDealImageErr', // Уникальный идентификатор
              type: 'error', // Тип уведомления
              message: `Файл ${file.name} неподдерживаемого типа` // Текст сообщения
            });
          }
        })
        if (rightFiles.length > 0 ) {
          onSubmit({ upload: true });
          // enqueueSnackbar('Загрузка изображения...', { variant: 'info', autoHideDuration: 5000 });
          showNotification({
            id: 'uploadMarketImage', // Уникальный идентификатор
            type: 'info', // Тип уведомления
            message: 'Загрузка' // Текст сообщения
          });

          postImage(rightFiles, socket.id, {user_id, role, content_type:"uploadMarketIcon"}).then(() => { selectedFiles = []; onSubmit({ upload: false });});
        }
      }
      if (selectedFiles) {
        onSubmit({ upload: true });
        enqueueSnackbar('Загрузка изображения...', { variant: 'info', autoHideDuration: 5000 });

        
      }
  }, [onSubmit]);

   const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { fontSize: adaptiveTitleSize, ref: titleRef } = useAdaptiveFontSize({ min: 20, max: 45, ratio: 0.045 });

  if (loading) return <Loading />;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        height: "100%",
        overflowY: "auto",
        paddingRight: "10px",
      }}
    >
      {/*АВАТАР*/}
      <div style={{ marginTop: "2%", width:"100%", display:"flex", flexDirection: 'row', alignItems: "flex-end", justifyContent: 'center', marginLeft: 35}}>
        <UserAvatar
          src={user.photo}
          userData={user}
          user_id={user_id}
          // @ts-ignore
          size={"150px"}
        />

        <input
          type="file"
          style={{ display: "none" }}
          id="upload-avatar"
          onChange={handleFileUpload}
        />

        <label
          htmlFor="upload-avatar"
          style={{
            bottom: 0,
          }}
        >
          <img src={EditIcon} width={35} height={35} alt="" />
        </label>
      </div>

      {/*НАСТРОЙКИ*/}
      <Box sx={{ width: "100%", padding: "20px 20px" }}>
        <TextInputDesign
          title="ФИО:"
          val={user.fio}
          onChange={(e) => change("fio", e)}
          adaptive
        />
      </Box>

      <Box sx={{ width: "100%", padding: "20px 20px" }}>
        <TextInputDesign
          title="Email:"
          val={user.email}
          onChange={(e) => change("email", e)}
          adaptive
        />
      </Box>

      <Box sx={{ width: "100%", padding: "20px 20px" }}>
        <TextInputDesign
          title="Телефон:"
          val={user.mobile_number}
          onChange={(e) => change("mobile_number", e)}
          adaptive
        />
      </Box>

      {/*ГРАНИЦА*/}
      <div style={{ marginTop: "10px", width: "100%" }}>
        <Divider
          orientation="horizontal"
          sx={{ borderBottomWidth: "10px", borderColor: "#e3e3e3" }}
        />
      </div>

      {/*МАРКЕТ*/}
      <Box sx={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", padding: "20px" }}>
  
      {/* Левый блок с текстом – растягивается */}
      <Box ref={titleRef} sx={{ flex: 1, minWidth: 0, pr: 2 }}>
        <Typography sx={{ fontSize: adaptiveTitleSize, color: "#838383" }}>
          Мой маркетплейс:
        </Typography>
      </Box>

      {/* Правый блок с картинкой – не сжимается */}
      <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-end", flexShrink: 0, gap: "8px" }}>
        {user.marketPhoto ? (
          <img
            src={user.marketPhoto}
            style={{ borderRadius: "12px", width: "60px", height: "60px", objectFit: "cover" }}
            alt=""
          />
        ) : (
          <HomeIcon sx={{ width: 60, height: 60 }} />
        )}

        <input type="file" style={{ display: "none" }} id="upload-market" onChange={handleMarketFileUpload} />
        <label htmlFor="upload-market" style={{ cursor: "pointer" }}>
          <img src={EditIcon} width={30} height={30} alt="" />
        </label>
      </div>

    </Box>

      {/*СОХРАНИТЬ*/}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginTop:'20px',
          paddingRight:'25px'
        }}
      >
        {changed && (
          <Button
            onClick={save}
            variant="contained"
            sx={{
              textTransform: "none",
              backgroundColor: colors.elements,
              fontWeight: "bold",
            }}
          >
            Сохранить
          </Button>
        )}
      </div>
    </div>
  );
};

export default ClientSettings;
